var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('h2',[_vm._v("Submittal Document Preview")]),_vm._v(" "),_c('p',[_vm._v("We are now generating your submittal. Large submittals will take longer to generate than smaller ones.")])])
}]

export { render, staticRenderFns }